import React from "react";
import tutorialCalendarIcon from "../../../../../assets/images/tutorialCalendarIcon.svg";
import './TutorialDatesCal.css';

const TutorialDatesCal = ({title,description}) => {
  return (
    <div className="tutorialContentBox TutorialDatesCalContentBox">
      <div className="imgBtnBox">
        <img
          alt="tutorialCalendarIcon"
          className="TutorialDatesCalImg"
          src={tutorialCalendarIcon}
        />
      </div>
      <p className="title">{title}</p>
      <p className="desc">
        {description}
      </p>
    </div>
  );
};

export default TutorialDatesCal;
